import React, { useState } from 'react';
import { StoreActions } from '../../state/store';
import Dialog from '../layout/Dialog';
import Panel from '../layout/Panel';
import { LayoutOrientations, QuizType, QuizRevealAnswers, defaultQuizSettings, AllowRetriesOptions } from '../../globals';
import DropdownProperty from '../properties/DropdownProperty';
import Spacer from '../layout/Spacer';
import NumberProperty from '../properties/NumberProperty';
import BoolProperty from '../properties/BoolProperty';
import { TooltipKeys } from '../tooltips/TooltipKeys';
import { useTypedDispatch, useTypedSelector } from '../../state/hooks';

interface IQuizSettingsDialogProps
{
	onShutdown?: () => void;
}

export default function QuizSettingsDialog(props: IQuizSettingsDialogProps)
{
	const dispatch = useTypedDispatch();
	const quizSettings = useTypedSelector(state => state.checklistModule.quizSettings);
	const [tempQuizSettings, setTempQuizSettings] = useState(quizSettings?.type ? { ...quizSettings } : {...defaultQuizSettings});

	function submitQuizSettings()
	{
		console.log('saving ', tempQuizSettings);
		dispatch(StoreActions.checklist.setQuizSettings(tempQuizSettings));
		onSD();
	}

	function onSD()
	{
		if(props.onShutdown)
		{
			props.onShutdown();
		}
	}

	return (
		<Dialog
			title={"Quiz Settings"}
			className={"assetSwapDialogRoot"}
			contentStyle={{ overflow:'hidden' }}
			data-name={"quiz-settings-dialog-root"}
			actions={[
				{
					label: "Confirm",
					onClick: submitQuizSettings,
				},
				{
					label: "Cancel",
				}
			]}
			onShutdown={onSD}
		>
			<Panel style={{ maxHeight:'100%', height:'100%' }}>
				<DropdownProperty
					data-name={"checklist-quiz-type"}
					label="Quiz Type"
					options={[
						{ display: "Graded Assessment", value: QuizType.GRADED },
						{ display: "Knowledge Check", value: QuizType.UNGRADED },
					]}
					value={tempQuizSettings.type}
					onChangeCallback={(v) => { setTempQuizSettings({ ...tempQuizSettings, type: v }) }}
				/>
				{
					tempQuizSettings.type === QuizType.UNGRADED ? <></> :
						<Panel orientation={LayoutOrientations.Horizontal} expand={false}>
							<Spacer size={{ x:'20px' }}/>
							<Panel>
								<NumberProperty
									data-name={'quiz-settings-passing-score'}
									min={0}
									max={100}
									step={1}
									key={'passingScore'}
									label={'Passing score'}
									value={tempQuizSettings.passingScore ?? 80}
									onChangeCallback={(v)=>{ setTempQuizSettings({ ...tempQuizSettings, passingScore: v }) }}
									onCommitCallback={(v)=>{ setTempQuizSettings({ ...tempQuizSettings, passingScore: v }) }}
								/>
								<BoolProperty
									data-name={"quiz-settings-practice-sessions"}
									value={tempQuizSettings.practiceSessions ?? true}
									label={"Allow practice Sessions"}
									onChangeCallback={(v)=>{ setTempQuizSettings({ ...tempQuizSettings, practiceSessions: v }) }}
								/>
								<DropdownProperty
									data-name={"quiz-settings-graded-retries"}
									label="Allow retries"
									options={[
										{ display: "Never", value: AllowRetriesOptions.NEVER },
										{ display: "Fail Only", value: AllowRetriesOptions.FAIL_ONLY },
										{ display: "Pass or Fail", value: AllowRetriesOptions.PASS_OR_FAIL },
									]}
									value={tempQuizSettings.allowRetries ?? AllowRetriesOptions.NEVER}
									onChangeCallback={(v) => { setTempQuizSettings({...tempQuizSettings, allowRetries: v}) }}
								/>
								{
									tempQuizSettings.allowRetries && tempQuizSettings.allowRetries !== AllowRetriesOptions.NEVER ?
										<NumberProperty
											data-name={'quiz-settings-retries-amount'}
											min={1}
											max={100}
											step={1}
											key={'gradedattempts'}
											label={'Number of retries'}
											value={tempQuizSettings.gradedAttempts ?? 1}
											onChangeCallback={(v)=>{ setTempQuizSettings({ ...tempQuizSettings, gradedAttempts: v }) }}
											onCommitCallback={(v)=>{ setTempQuizSettings({ ...tempQuizSettings, gradedAttempts: v }) }}
										/> : <></>
								}
							</Panel>
						</Panel>
				}
				<DropdownProperty
					data-name={"quiz-settings-reveal-answers"}
					label="Show Correct Answers"
					tooltip={TooltipKeys.QuizSettingsShowCorrectAnswers}
					options={[
						{ display: "Never", value: QuizRevealAnswers.NEVER },
						{ display: "Always", value: QuizRevealAnswers.ALWAYS },
						{ display: "Knowledge checks only", value: QuizRevealAnswers.UNGRADED },
						{ display: "Graded questions only", value: QuizRevealAnswers.GRADED },
					]}
					value={tempQuizSettings.revealAnswers ?? QuizRevealAnswers.ALWAYS}
					onChangeCallback={(v) => { setTempQuizSettings({ ...tempQuizSettings, revealAnswers: v }) }}
				/>

			</Panel>
		</Dialog>
	);
}
